import Box from "@mui/material/Box";
import React from "react";
import { SectionTitle } from "./LatestProducts";
import {
  Button,
  Container,
  styled,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import prod1 from "../assets/images/products/prod1.webp";
import prod1_2 from "../assets/images/products/prod1_2.webp";
import LatestProduct from "./Product";
import { AnimatePresence, motion } from "framer-motion";
import { useGetLimitProductsQuery } from "../services/queries";
import ProductSkelton from "./ProductSkeltoon";
import Product from "./Product";
import { ChangeProductGridDisplay } from "../redux/UI/UIReducer";

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          component={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          sx={{ py: { xs: 0, sm: 0, md: 1 } }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const ProductsSelectionBox = styled((props) => (
  <Box {...props}>{props.children}</Box>
))(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(2),
  justifyContent: "center",
  boxSizing: "border-box",
}));
export const StyledTab = styled((props) => (
  <Tab {...props}>{props.children}</Tab>
))(({ theme }) => ({
  borderRadius: "20px",
  boxSizing: "border-box",
  // borderColor:'transparent',
  border: "1px solid transparent",
  transition: "0.5s",
  color: "gray",
  fontFamily: "lato",
  padding: "1px 15px",

  "&:hover": {
    color: "black",
    // borderColor: "black",
  },
  "&.Mui-selected": {
    color: "black",
    borderColor: "black",
  },
}));

export default function OurProducts() {
  const productsQuery = useGetLimitProductsQuery(12);
  console.log(productsQuery.data);
  // const products = [
  //   {
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: 50.0,
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  //   {
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: "",
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  //   {
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: "",
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  // ];
  // const products1 = [
  //   {
  //     img1: prod1_2,
  //     img2: prod1,
  //     title: "blue cotton leggings",
  //     oldPrice: 50.0,
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  //   {
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: "",
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  //   {
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: "",
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  // ];
  // const products2 = [
  //   {
  //     img1: prod1_2,
  //     img2: prod1,
  //     title: "blue cotton leggings",
  //     oldPrice: 50.0,
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  //   {
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: "",
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  //   {
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: "",
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  // ];

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Container
      sx={{
        my: { lg: 8, md: 6, sm: 4, xs: 4 },
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SectionTitle>Our Products</SectionTitle>
      <ProductsSelectionBox>
        <Tabs
          sx={{
            "& .MuiTabs-flexContainer": { gap: { xs: 2, sm: 2, md: 4, lg: 4 } },
            "& .MuiTabs-indicator": { display: "none" },
          }}
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <StyledTab label="Best Seller" {...a11yProps(0)} />
          <StyledTab label="Sale" {...a11yProps(1)} />
          <StyledTab label="Featured" {...a11yProps(2)} />
          <StyledTab label="Top Rate" {...a11yProps(3)} />
        </Tabs>
      </ProductsSelectionBox>
      <Box
        sx={
          {
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
          }
        }
      >
        <TabPanel value={value} index={0}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                sm: "repeat(1, minmax(0, 1fr))",
                md: "repeat(2, minmax(0, 2fr))",
                lg: "repeat(3, minmax(0, 3fr))",
              },
              flexDirection: { xs: "row" },
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "start",
            }}
          >
            {productsQuery.isLoading && <ProductSkelton />}
            {productsQuery.isError && (
              <h4 style={{ textAlign: "center", width: "100%" }}>
                something wrong happened...try again!
              </h4>
            )}
            {productsQuery.isSuccess &&
              productsQuery.data.data
                .slice(0, 3)
                .map((prod, index) => (
                  <Product
                    id={prod.id}
                    productDisplayprop={ChangeProductGridDisplay}
                    key={index}
                    img1={prod.image}
                    img2={prod.image}
                    title={prod.title}
                    oldPrice={prod.price - (prod.price * 10) / 100}
                    newPrice={prod.price}
                    colors={["green", "white", "blue"]}
                    link={prod.link}
                    sale={prod.sale}
                    details={prod.details}
                  />
                ))}
          </Box>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                sm: "repeat(1, minmax(0, 1fr))",
                md: "repeat(2, minmax(0, 2fr))",
                lg: "repeat(3, minmax(0, 3fr))",
              },
              flexDirection: { xs: "row" },
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "start",
            }}
          >
            {productsQuery.isLoading && <ProductSkelton />}
            {productsQuery.isError && (
              <h4 style={{ textAlign: "center", width: "100%" }}>
                something wrong happened...try again!
              </h4>
            )}
            {productsQuery.isSuccess &&
              productsQuery.data.data
                .slice(3, 6)
                .map((prod, index) => (
                  <Product
                    id={prod.id}
                    productDisplayprop={ChangeProductGridDisplay}
                    key={index}
                    img1={prod.image}
                    img2={prod.image}
                    title={prod.title}
                    oldPrice={prod.price - (prod.price * 10) / 100}
                    newPrice={prod.price}
                    colors={["green", "white", "blue"]}
                    link={prod.link}
                    sale={prod.sale}
                    details={prod.details}
                  />
                ))}
          </Box>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                sm: "repeat(1, minmax(0, 1fr))",
                md: "repeat(2, minmax(0, 2fr))",
                lg: "repeat(3, minmax(0, 3fr))",
              },
              flexDirection: { xs: "row" },
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "start",
            }}
          >
            {productsQuery.isLoading && <ProductSkelton />}
            {productsQuery.isError && (
              <h4 style={{ textAlign: "center", width: "100%" }}>
                something wrong happened...try again!
              </h4>
            )}
            {productsQuery.isSuccess &&
              productsQuery.data.data
                .slice(6, 9)
                .map((prod, index) => (
                  <Product
                    id={prod.id}
                    productDisplayprop={ChangeProductGridDisplay}
                    key={index}
                    img1={prod.image}
                    img2={prod.image}
                    title={prod.title}
                    oldPrice={prod.price - (prod.price * 10) / 100}
                    newPrice={prod.price}
                    colors={["green", "white", "blue"]}
                    link={prod.link}
                    sale={prod.sale}
                    details={prod.details}
                  />
                ))}
          </Box>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                sm: "repeat(1, minmax(0, 1fr))",
                md: "repeat(2, minmax(0, 2fr))",
                lg: "repeat(3, minmax(0, 3fr))",
              },
              flexDirection: { xs: "row" },
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "start",
            }}
          >
            {productsQuery.isLoading && <ProductSkelton />}
            {productsQuery.isError && (
              <h4 style={{ textAlign: "center", width: "100%" }}>
                something wrong happened...try again!
              </h4>
            )}
            {productsQuery.isSuccess &&
              productsQuery.data.data
                .slice(9, 12)
                .map((prod, index) => (
                  <Product
                    id={prod.id}
                    productDisplayprop={ChangeProductGridDisplay}
                    key={index}
                    img1={prod.image}
                    img2={prod.image}
                    title={prod.title}
                    oldPrice={prod.price - (prod.price * 10) / 100}
                    newPrice={prod.price}
                    colors={["green", "white", "blue"]}
                    link={prod.link}
                    sale={prod.sale}
                    details={prod.details}
                  />
                ))}
          </Box>
        </TabPanel>

        {/* <Box sx={{ display:'flex',gap:2  }}>
            <StyledButton>best seller</StyledButton>
            <StyledButton>sale</StyledButton>
            <StyledButton>featured</StyledButton>
            <StyledButton>top rate</StyledButton>
            </Box> */}
      </Box>
    </Container>
  );
}
